var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-container" }, [
    _c(
      "div",
      { staticClass: "messages" },
      _vm._l(_vm.messages, function(message, j) {
        return _c(
          "div",
          {
            key: "forced-message--" + j,
            staticClass: "message",
            style: { "animation-delay": j + "s" }
          },
          [_c("span", { domProps: { innerHTML: _vm._s(message) } })]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "item-edit",
        style: { "animation-delay": _vm.messages.length + "s" }
      },
      [
        _vm.typeIsPreExperience
          ? [
              _c(
                "b-row",
                { staticClass: "mb-4", attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("Avatar", {
                        attrs: { avatar: _vm.avatarCatNotebook, fluid: "" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }